export const LocationHelper = {
    getHostname: (): string => window.location.hostname,
    getPathname: (): string => window.location.pathname,
    getHost: (): string => window.location.host,
    getProtocol: (): string => window.location.protocol,
};
